module.exports = __webpack_public_path__ + "img/btn-kaishi.33f2d4f5.png";